import React from "react"
export function Support(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M16.75 13l-.004.22a5.75 5.75 0 01-5.52 5.526L11 18.75h-1v-1.5h1l.206-.005a4.25 4.25 0 003.544-2.243h-2a1 1 0 01-1-1v-3a1 1 0 011-1l2.5-.001V8.75a5.25 5.25 0 00-5.034-5.246L10 3.5v.007l-.216.004a5.25 5.25 0 00-5.03 5.024l-.004.222v1.248h2.5a1 1 0 011 1v3a1 1 0 01-1 1h-1.5a2.5 2.5 0 01-2.5-2.5V8.758l.004-.237a6.75 6.75 0 016.509-6.509L10 2.007V2a6.75 6.75 0 016.746 6.513l.004.237V13z"
        fill="currentColor"
        id="prefix__support"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
